import { jsx } from "react/jsx-runtime";
import React__default from "react";
const InitialBlockEnvironment = {
  environment: "prod"
};
const BlockEnvironmentContext = React__default.createContext(InitialBlockEnvironment);
const BlockEnvironmentProvider = ({
  children,
  environment
}) => {
  const value = {
    environment
  };
  return /* @__PURE__ */ jsx(BlockEnvironmentContext.Provider, { value, children });
};
const useBlockEnvironment = () => {
  return React__default.useContext(BlockEnvironmentContext);
};
export {
  BlockEnvironmentProvider,
  useBlockEnvironment
};
